import React from 'react'
import { useFormState } from 'react-final-form'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'

import Container, { Content, Header } from '~/components/Container'
import PageTitle from '~/components/PageTitle'
import { DiscardButton, SaveButton } from '~/components/Buttons'
import { withForm } from '~/components/Form'
import { BackgroundSingleFileUpload } from '~/components/BackgroundFileUpload'
import { TemplateCard } from '~/components/FileUpload'
import * as API from '~/constants/api'
import * as NAV from '~/constants/nav-titles'
import { useGoogleEvent } from '~/components/GoogleAnalytics/GoogleAnalytics'

import UploadedFile from './UploadedFile'
import CityMappingProgressCard from './CityMappingProgressCard'

function CityMappingImport ({ title, form, isLoading, progressCard, onSubscribe, onFileRemove, submitted }) {
  const { handleSubmit } = form
  const { sendEvent } = useGoogleEvent()
  const formState = useFormState()

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Header>
          <PageTitle
            pageTitle={title}
            parentTitle={NAV.CITY_MAPPING}
            rightButton={(
              <>
                <DiscardButton disabled={isLoading} />
                <SaveButton disabled={isLoading || !formState.values.file || submitted} />
              </>
            )}
          />
        </Header>

        <Content>
          <Grid container={true} spacing={3}>
            <Grid item={true} xs={12} lg={8}>
              <BackgroundSingleFileUpload
                name="file"
                api={API.CITY_MAPPING_FILE_VALIDATION}
                onSubscribe={onSubscribe}
                Component={UploadedFile}
                onRemove={onFileRemove}
              />
            </Grid>
            <Grid item={true} xs={12} lg={4}>
              <Grid container={true} spacing={3}>
                <Grid item={true} xs={12}>
                  <TemplateCard
                    fileName="Carrier%20City%20Mappings.xlsx"
                    onClick={() => sendEvent({
                      eventAction: 'Template File Download City Mapping',
                      eventCategory: 'City Mapping'
                    })}
                  />
                </Grid>

                <Grid item={true} xs={12}>
                  <CityMappingProgressCard
                    title="Progress"
                    validation={progressCard.validation}
                    completion={progressCard.completion}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Container>
    </form>
  )
}

CityMappingImport.propTypes = {
  form: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  progressCard: PropTypes.object.isRequired,
  onSubscribe: PropTypes.func.isRequired,
  submitted: PropTypes.bool.isRequired,
  onFileRemove: PropTypes.func.isRequired
}

export default withForm(CityMappingImport)
